function initOrderModal() {

    const documentBody = document.querySelector('body'); 
    const orderPublicationBtns = document.querySelectorAll('.order-publication-btn');
    const basketPosition = document.querySelector('#basket-position');

    let formSend = false;


    function validationError() {

        const orderHolderScroll = document.getElementById('order-holder-scroll');
        const erroralert        = orderHolderScroll.querySelector('.erroralert');
        const sendingalert      = orderHolderScroll.querySelector('.sendingalert');

        TweenMax.to(orderHolderScroll, 0.6, {
            scrollTo:{
                y: 0, 
                //autoKill: true
            }, 
            ease:Power2.easeInOut
         });

        erroralert.classList.remove('d-none'); 
        sendingalert.classList.add('d-none');
    }

    function showSendingAlert(html) { 

        const orderHolderScroll = document.getElementById('order-holder-scroll');
        const formCollapse      = document.getElementById('form-collapse');
        const erroralert        = orderHolderScroll.querySelector('.erroralert');
        const sendingalert      = orderHolderScroll.querySelector('.sendingalert');

        sendingalert.innerHTML = '';
        sendingalert.innerHTML = html;
        erroralert.classList.add('d-none'); 
        gsap.set(sendingalert, {opacity: 0});
        sendingalert.classList.remove('d-none');
        var topY = offset(formCollapse).top ;  
         //bsFormCollapse.hide();

        TweenMax.to(formCollapse, 0.2, {
                scrollTo:{
                    y: topY, 
                    //autoKill: true
                }, 
                ease:Power2.easeInOut,
                delay: 0.9,
             });

        gsap.to(formCollapse, 0.8, {height:0, ease:Power2.easeInOut, onComplete: function(){ 

            setTimeout(function(){

                 gsap.to(sendingalert, 0.2, {opacity:1, ease:Power2.easeInOut});

            },100)

        }});

    }

    function initFormValidation(){

        const form = document.querySelector('#order-form');

        // Loop over them and prevent submission
        form.addEventListener('submit', function(event) {

        if (form.checkValidity() === false) {

            event.preventDefault();
            event.stopPropagation();


            validationError();


        } else {

            event.preventDefault();
            event.stopPropagation();


                SendForm();
        }

        form.classList.add('was-validated');
        }, false);
    }

    function SendForm() {




        const inputFinalize = document.getElementById('finalize');

        inputFinalize.value = 'true';

        // Get the form
        const form = document.querySelector('#order-form');

        loading.show(form,'neg','absolute');


        // Get all field data from the form
        const formdata = new FormData(form);

        // Convert to an object
        //let data = serialiseForm(form);
        const queryString = new URLSearchParams(formdata).toString();


        setTimeout(function(){

            var request = new XMLHttpRequest();

            //cursor.setAjaxState();
            request.open('POST', ajaxurl, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        // If successful

                        const responseHtml = this.response;

                        loading.hide();
                        setTimeout(function(){
                            showSendingAlert(responseHtml);
                            resetBasket();
                            formSend = true;
                        },400);

                    } else {
                        // If fail
                        loading.hide();
                        setTimeout(function(){
                            showSendingAlert('<div class="alert alert-danger ">Das Formular konnte nicht verschickt werden.</div>');
                        },400);
                        //console.log(this.response);
                    }
                };
                request.onerror = function() {
                        loading.hide();
                        setTimeout(function(){
                            showSendingAlert('<div class="alert alert-danger ">Das Formular konnte nicht verschickt werden.</div>');
                        },400);
                };
                request.send('action='+'send_form'+'&' + queryString);

        },600);
    }

    function loadModal(formTyp, posttId, standortId) {


        //loading.show(documentBody, 'pos', 'fixed');

        var request = new XMLHttpRequest();
        //cursor.setAjaxState();
        request.open('POST', ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                openModal(formTyp, this.responseText, posttId, standortId);
            } else {
                // If fail
                openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                //console.log(this.response);
            }
        };
        request.onerror = function() {
            openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
        };
        request.send('action=load_form_modal&formTyp='+formTyp+'&postId='+posttId+'&standortId=' + standortId);   
    }

    function openOrderModal(html, orderId, orderText){

        if (html) {
            appendModalHtml(html);
        }

        const infoModalHolder   = document.querySelector('#order-holder');
        const infoModalInner    = document.querySelector('#order-content-holder');
        const closeTrigger      = infoModalHolder.querySelector('.btn-circle-close');
        const btnAddMore        = infoModalHolder.querySelector('.btn-add-more');
        const textArea          = document.getElementById('textareaComment');  


        if (orderId && orderText) {
            setOrderInput(orderId, orderText);
        }


        gsap.set(infoModalInner, {x: -50,transformOrigin: '0% 0%'});

        document.body.classList.add('overflow-hidden');

        gsap.to(infoModalHolder, {ease: Power1.easeOut, x: 0,  duration: 0.6, onComplete(){
        }});
        setTimeout(function(){ 
            gsap.to(infoModalInner, {ease: Power1.easeIn, x: 0,  duration: 0.3, onComplete(){

            }});

        },380);

        closeTrigger.addEventListener('click', function(){

            closeInfoModal();
        });

        btnAddMore.addEventListener('click', function(e){

            e.preventDefault();

            closeInfoModal();
        });
        textArea.addEventListener('keyup', countCharacters, false);

       

    }

    function closeInfoModal(){ 

        const orderModalHolder   = document.querySelector('#order-holder');
        const orderModalInner    = document.querySelector('#order-content-holder');
        const erroralert        = orderModalHolder.querySelector('.erroralert');

        document.body.classList.remove('overflow-hidden');

        gsap.to(orderModalInner, {ease: Power1.easeIn, x: -50,  duration: 0.3, onComplete(){}});
        
        setTimeout(function(){ 
            gsap.to(orderModalHolder, {ease: Power1.easeOut, x: '-100%',  duration: 0.6, onComplete(){

                erroralert.classList.add('d-none'); 

                if (formSend) {

                    resetForm();

                }

            }});
        },380);

    }

    function loadModal(orderId, orderText) {


        if (document.querySelector('#order-holder')) {


            openOrderModal(false, orderId, orderText);


        } else {

            loading.show(documentBody,'neg','fixed');

            var request = new XMLHttpRequest();
            //cursor.setAjaxState();
            request.open('POST', ajaxurl, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    // If successful
                    openOrderModal(this.responseText, orderId, orderText);
                    loading.hide();
                } else {
                    // If fail
                    openOrderModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                    loading.hide();
                } 
            };
            request.onerror = function() {
                openOrderModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                loading.hide();
            };
            request.send('action=load_order_modal');

        }


    }

    function resetForm() {

        const orderHolder   = document.querySelector('#order-holder');
        orderHolder.remove();

    }

    function setOrderInput(orderId, orderText) {

        const infoModalHolder       =  document.querySelector('#order-holder');
        const orderItemsHolder      =  infoModalHolder.querySelector('.order-items-holder');

        if (orderItemsHolder.querySelector('.'+orderId)) {

            return false;
        }


        const html = `<div class="order-item  ${orderId} pt-3  pb-3 border-bottom">
                        <div class="row">
                            <div class="col-sm-8 mb-3 mb-sm-0">
                                <h5 class="mb-0 text-secondary">${orderText}</h5>
                            </div>
                            <div class="col-sm-4 text-end">
                                <button class="btn btn-outline-danger btn-sm btn-delete">löschen</button>
                            </div>
                        </div>
                        <input type="hidden" name="order-item[]" value="${orderText}">
                    </div>`;

        appendHtml(orderItemsHolder, html);

        document.querySelector('#'+orderId).classList.add('picked');

       const deleteBt =  document.querySelector('.'+orderId+' .btn-delete');

       deleteBt.addEventListener('click', function(){

            document.querySelector('.'+orderId).remove();
            document.querySelector('#'+orderId).classList.remove('picked');
            updateBasket(orderItemsHolder.querySelectorAll('.order-item').length);

       });

       setTimeout(function(){
            updateBasket(orderItemsHolder.querySelectorAll('.order-item').length);
       },600);

    }

    function appendModalHtml(content, orderId, orderText) {

        const html = `<div class="order-holder bg-dark text-light" id="order-holder">
                        <button class="btn-circle-close"><span class="visually-hidden-focusable">schliessen</span></button>
                        <div class="overflow-scroll h-100 position-relative" id="order-holder-scroll">
                            <div class="container pt-4 pb-4" id="order-content-holder">
                                ${content}
                            </div>
                        </div>
                    </div>`;

         appendHtml(document.querySelector('body'), html);
         initFormValidation();
        return html;

       
    }

    function updateBasket(count) {

        const html =    `<button class="publication-basket position-relative">
                            <div class="basket-icon"></div><span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary text-dark">
                            <span id="basket-count"></span>
                            <span class="visually-hidden"><Anzahl Publikationen</span></span>
                        </button>`;

        if (!document.querySelector('.publication-basket')) {

            appendHtml(basketPosition, html);
        }

        const publicationBasketCount    =  document.querySelector('.publication-basket #basket-count');
        const publicationBasket         =  document.querySelector('.publication-basket');

        publicationBasketCount.innerHTML = count;

        publicationBasket.addEventListener('click', function(){

            openOrderModal();

        });






    }

    function resetBasket() {

        const infoModalHolder           =  document.querySelector('#order-holder');
        const orderItemsHolder          =  infoModalHolder.querySelector('.order-items-holder');
        const publicationBasketCount    =  document.querySelector('.publication-basket #basket-count');

        const publicationSingles       =  document.querySelectorAll('.publication-single');

        publicationSingles.forEach(publicationSingle => {
            publicationSingle.classList.remove('picked');
        });

        orderItemsHolder.innerHTML          = '';
        publicationBasketCount.innerHTML    = '0';

    }

    function countCharacters(e) {
        
        
        var textEntered, countRemaining, counter;          
        textEntered = document.getElementById('textareaComment').value;  
        counter = (1000 - (textEntered.length));
        countRemaining = document.getElementById('charactersRemaining'); 
          
          if (counter <= 10) {
              
              countRemaining.classList.add('text-danger');
              countRemaining.classList.remove('text-muted'); 
              
              
          } else {
              countRemaining.classList.remove('text-danger');
              countRemaining.classList.add('text-muted');
          }
           
        countRemaining.textContent = counter +'/1000';    
       
      }

    orderPublicationBtns.forEach(orderPublicationBtn => {

        orderPublicationBtn.addEventListener('click', function(e){

            e.preventDefault;

            const orderId   = this.dataset.orderId;
            const orderText = this.dataset.orderText;

            loadModal(orderId, orderText);
        });
    });

    return {

       // openMenu:  openMenu,
       // closeMenu: closeMenu
    }
}
